export * from './shared/registry'
export * from './serasa/generic/registry'
export * from './pague-veloz/registry'
